import React, { useEffect, useState } from 'react';
//import { BrowserRouter, useNavigate } from "react-router-dom";
import { setNavigator } from "./utils/navigation";
import { MessageHolder } from "./utils/messageService";
import './App.scss';
import { App as AntApp } from 'antd';
import {
  Route,
  BrowserRouter as Router,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  useNavigate
} from 'react-router-dom'
import Login from './pages/Login'
import DummyLayout from './pages/PageLayout/DummyLayout';
import Dashboard from './pages/Dashboard/Dashboard.jsx'
import InternalDashboard from './pages/InternalDashboard/InternalDashboard.jsx'
import Detections from './pages/Detections'
//import DeploymentsPage from './pages/Deployments'
import UsersPage from './pages/Users';
//import { useAuthStore, useCustomerStore, useRoleStore } from './store';
import RequireAuth from './utils/RequireAuth';
import SMSConsent from './pages/SMSConsent';
import ApiInfo from './pages/ApiInfo';
import Page404 from './pages/404page'
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermConditions';
import LocationsPage from './pages/Locations';
import ProjectsPage from './pages/Projects';
import HardwarePage from './pages/HardwareInfo';
import SchedulePage from './pages/NewSchedules';
import ProfilePage from './pages/Profile';
import NewZonesPage from './pages/NewZones';
import { VideoProvider } from './pages/VMS/VideoContext';
import ErrorPage from './pages/ErrorPage';
import DetectionTypesPage from './pages/DetectionTypes';
import HardwareTypesPage from './pages/HardwareTypes';
import CustomersPage from './pages/Customers';
import HardwareInfoPage from './pages/HardwareInfo';
import MapPage from './pages/Maps';
import DataTypesPage from './pages/DataTypes';
import StreamResolutionsPage from './pages/StreamResolutions';
import NotificationsPage from './pages/Notifications';
import VMSPage from './pages/VMS';
import DetectionPackagePage from './pages/DetectionPackage';
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager, IntegratedChartsModule } from "ag-grid-enterprise";
import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
//import OldDeploymentsPage from './pages/Deployments';
import { DeploymentsPage, OldDeploymentsPage } from './pages/Deployments/index.js';
import WeeklyReportPage from './pages/WeeklyReport/index.js';
import ConfigsPage from './pages/Configs/index.js';
import CredentialsPage from './pages/Credentials'
import NotesPage from './pages/Notes/index.js';
import EmailChainPage from './pages/EmailChains/index.js';
import EmailTrackingPage from './pages/EmailTracking/index.js';
import LogosPage from './pages/Logos/index.js';
import GlobePage from './pages/Globe/index.js';
import EmailFormatsPage from './pages/EmailFormats/index.js';

ModuleRegistry.registerModules([
    AllEnterpriseModule,
    IntegratedChartsModule.with(AgChartsEnterpriseModule)
]);
LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);

function App() {

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path='/' element={<DummyLayout />} errorElement={<ErrorPage />}>
          <>
            
            <Route element={<RequireAuth allowedRoles={['super administrator', 'administrator', 'user', 'read-only', 'customer success', 'validator']} />}>
              <Route index element={<Dashboard />} />
              <Route path='dashboard' element={<Dashboard />} handle={{ scrollMode: "pathname" }} />
              <Route path='internaldashboard' element={<InternalDashboard />} handle={{ scrollMode: "pathname" }} />
              <Route path='deployments' element={<DeploymentsPage />} handle={{ scrollMode: "pathname" }} />
              <Route path='old_deployments' element={<OldDeploymentsPage/>} handle={{ scrollMode: "pathname" }} />
              <Route path='vms/:deployment_id/:location_name/:unix_timestamp_s?' element={<VideoProvider> <VMSPage/> </VideoProvider>} />
              <Route path='users' element={<UsersPage />} handle={{ scrollMode: "pathname" }} />
              <Route path='profile' element={<ProfilePage />} />
              <Route path='schedule/:deployment_id/:location_name' element={<SchedulePage/>}/>
              <Route path='zones/:deployment_id/:location_name' element={<NewZonesPage/>}/>
              <Route path='notifications/:deployment_id/:location_name' element={<NotificationsPage/>}/>
               <Route path='events' element={<Detections />} />
               <Route path='globe' element={<GlobePage/>}/>

              
            </Route>

            <Route element={<RequireAuth allowedRoles={['super administrator', 'administrator', 'user', 'read-only']} />}>
            </Route>

            <Route element={<RequireAuth allowedRoles={['super administrator', 'administrator', 'user']} />}>
            </Route>
      
            <Route element={<RequireAuth allowedRoles={['super administrator', 'administrator']} />}>

            </Route>

            <Route element={<RequireAuth allowedRoles={['super administrator']} />}>
              <Route path='apidata' element={<ApiInfo />} />
              <Route path='detection-types' element={<DetectionTypesPage />}/>
              <Route path='hardware-info' element={<HardwareInfoPage />}/>
              <Route path='hardware-types' element={<HardwareTypesPage />}/>
              <Route path='customers' element={<CustomersPage />}/>
              <Route path='locations' element={<LocationsPage />} />
              <Route path='projects' element={<ProjectsPage />} />
              <Route path='hardware' element={<HardwarePage />} />
              <Route path='map' element={<MapPage />}/>
              
              <Route path='data-types' element={<DataTypesPage />}/>
              <Route path='stream-resolutions' element={<StreamResolutionsPage />}/>
              <Route path='detection-packages' element={<DetectionPackagePage/>}/>
              <Route path='weekly-report' element={<WeeklyReportPage/>}/>
              <Route path='configs' element={<ConfigsPage/>}/>
              <Route path='credentials' element={<CredentialsPage/>}/>
              {/* <Route path='notes' element={<NotesPage/>}/> */}
              <Route path='email-chains' element={<EmailChainPage/>}/>
              <Route path='email-tracking' element={<EmailTrackingPage/>}/>
              <Route path='email-formats' element={<EmailFormatsPage/>}/> 
              <Route path='logos' element={<LogosPage/>}/>
            </Route>
          </>

        </Route>
        <Route path='login/:hash?' element={<Login />} />
        <Route path='*' element={<Page404 />} />
        <Route path='sms-consent-agreement' element={<SMSConsent />} />
        <Route path='privacy' element={<PrivacyPolicy />} />
        <Route path='terms' element={<TermsConditions />} />
      </>
    )
  );

  useEffect(() => {
    // Set document title based on environment
    const developmentEnv = process.env.REACT_APP_DEVELOPMENT_ENV || 'production';
    document.title = developmentEnv === 'test' ? 'Orbital Test Portal' : 'Orbital Portal';
    
    // Hide fallback page once React has successfully mounted
    const fallbackPage = document.getElementById('fallback-page');
    if (fallbackPage) {
      console.log("Hiding fallback page - ReactJS mounted successfully");
      fallbackPage.classList.add('hidden');
    }
  }, []);

  return (
    <div className="App">
      <AntApp message={{ maxCount: 1 }}>
        <MessageHolder />
        <RouterProvider router={router} />
      </AntApp>
    </div>
  );
}

export default App;
